/* global ha */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchBox from '@homeaway/react-searchbox-lite';

import {setSearchData} from '../../../actions/search';
import {getSearchValues} from '../../../utils/search';
import {redirect} from '../../../actions/search';
import MvtTest from '../mvt/MvtTest/MvtTest';
import {TESTS} from '../../../utils/abacus';

export function mapStateToProps({abacus, config, destination, i18n, modules, search}) {
    const propertyType = destination.propertyType;

    return {
        abacus,
        basePathPrefix: config.url.basePathPrefix,
        details: destination.details,
        fabId: !isNaN(parseInt(propertyType, 10)) ? propertyType : null,
        lbsId: destination && destination.details ? destination.details.lbsId : null,
        searchValues: search,
        locale: i18n.locale,
        site: config.site,
        isMobile: config.isMobile,
        labels: modules.searchBoxLite.labels,
        resetForm: modules.searchBoxLite.resetForm
    };
}

export function mapDispatchToprops(dispatch) {
    return {
        setSearchData,
        dispatch
    };
}

export class SearchBoxLiteComponent extends Component {
    static propTypes = {
        basePathPrefix: PropTypes.string,
        details: PropTypes.shape({
            fullName: PropTypes.string
        }),
        geoType: PropTypes.string,
        isMobile: PropTypes.bool,
        lbsId: PropTypes.string,
        resetForm: PropTypes.bool,
        searchValues: PropTypes.shape({
            adults: PropTypes.number,
            arrivalDate: PropTypes.string,
            children: PropTypes.number,
            departureDate: PropTypes.string,
            petIncluded: PropTypes.bool
        }),
        showConsolidate: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        resetForm: false
    };

    componentDidMount() {
        ha.userTiming.mark('primary.action.rendered');
        ha.userTiming.mark('datepicker.active');

        const cookies = document.cookie;
        const {searchValues, abacus} = this.props;
        const searchCookies = getSearchValues(cookies, abacus);

        if (!searchCookies || !searchValues) {
            return;
        }

        const differentSearchData =
            searchValues.arrivalDate !== searchCookies.arrivalDate ||
            searchValues.departureDate !== searchCookies.departureDate ||
            searchValues.adults !== searchCookies.adults ||
            searchValues.children !== searchCookies.children ||
            searchValues.petIncluded !== searchCookies.petIncluded;

        if (differentSearchData) {
            this.props.dispatch(setSearchData(searchCookies));
        }
    }

    onSubmit = ({searchPath}) => {
        this.props.dispatch(redirect(searchPath));
    };

    render = () => {
        const {
            adults,
            children,
            petIncluded,
            departureDate,
            arrivalDate
        } = this.props.searchValues;

        const {
            basePathPrefix,
            fabId,
            isMobile,
            labels,
            lbsId,
            locale,
            resetForm,
            site
        } = this.props;

        const guests = {
            adultsCount: adults,
            childrenCount: children,
            petIncluded
        };

        const destination = resetForm ? '' : this.props.details.fullName;

        return (
            <React.Fragment>
                <SearchBox
                    checkIn={arrivalDate}
                    checkOut={departureDate}
                    onSubmit={this.onSubmit}
                    edapDatePickerLabel={'0'}
                    labels={labels}
                    domain={site.domain}
                    typeaheadProps={{
                        site: site.name,
                        baseUrl: `https://${site.domain}`,
                        appPrefix: basePathPrefix
                    }}
                    {...{lbsId, destination, guests, locale, isMobile, fabId}}
                />
                <MvtTest test={TESTS.DEFAULT_SEARCHBOX_DATES} />
            </React.Fragment>
        );
    };
}

export const SearchBoxLite = connect(mapStateToProps, mapDispatchToprops)(SearchBoxLiteComponent);

export default SearchBoxLite;
